<app-alt-pdf-viewer
  *ngIf="pdfAssetInfo && !signedUrl"
  [pdfAssetInfo]="pdfAssetInfo"
  [showDownloadButton]="showDownloadButton"
  [showCloseButton]="true"
  (downloadPdf)="downloadPdf()"
  (closePdfViewer)="onCloseAssetViewer()"
></app-alt-pdf-viewer>
<app-html-viewer
  *ngIf="signedUrl"
  [url]="signedUrl"
  [downloadPDFEnabled]="showDownloadButton"
  (closeAssetViewer)="onCloseAssetViewer()"
></app-html-viewer>
